import axios from "axios";
import { PCB_CORE_URL } from "../config";
import { clearAuthSession, getAccessToken, refreshAccessToken } from "../authSession";

const API_BASE = PCB_CORE_URL;


export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;

    if (status === 401 && original && !original._retry) {
      original._retry = true;
      const token = await refreshAccessToken();
      if (token) {
        original.headers = {
          ...(original.headers || {}),
          Authorization: `Bearer ${token}`,
        };
        return api(original);
      }
    }

    if (status === 401) {
      clearAuthSession();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }

    return Promise.reject(error);
  }
);

export function errorMsg(e, fallback) {
  return (
    e?.response?.data?.detail ||
    (typeof e?.response?.data === "string"
      ? e.response.data
      : e?.response?.data
      ? JSON.stringify(e.response.data)
      : "") ||
    e?.message ||
    fallback
  );
}

export async function uploadFile(path, file, extraFormFields = {}) {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(extraFormFields || {}).forEach(([k, v]) => fd.append(k, v));
  const res = await api.post(path, fd);
  return res.data;
}

export async function getJson(path) {
  const res = await api.get(path);
  return res.data;
}

export async function putJson(path, payload) {
  const res = await api.put(path, payload, { headers: { "Content-Type": "application/json" } });
  return res.data;
}

export async function putFile(path, fieldName, file) {
  const fd = new FormData();
  fd.append(fieldName, file);
  const res = await api.put(path, fd);
  return res.data;
}

export async function postJson(path, payload) {
  const res = await api.post(path, payload, { headers: { "Content-Type": "application/json" } });
  return res.data;
}
